// Arc summary. When the serial context's synopsis grows past its char budget,
// the oldest ~10 aged-out episode one-liners are folded into a single "arc"
// paragraph. This compresses the FAR narrative (which the model only needs as
// background) into a bounded chapter recap, instead of the old zero-LLM
// concatenation that just kept growing. Cheap model (ingest-low); fires rarely.

import type { LlmTaskExecutor } from "../../types.js";

export const ARC_SUMMARY_SYSTEM =
  "你是短剧连续转写里的「远端剧情浓缩器」。我会给你一段连续集区间的**逐条剧情梗概**(每行一集或一个更早的篇章)。它们是给模型当**背景前情**用的远端剧情,不需要逐集细节。" +
  "\n你的任务:把它们**浓缩成一段连贯的篇章梗概**,只保留:主线走向、关键转折、重要人物与其阵营/目标变化、影响后续的因果与伏笔。" +
  "\n要求:" +
  "\n- 一段连续文字,**不要**逐集罗列、不要分点、不要写「第N集」字样、不要任何标题。" +
  "\n- 保留出现的**关键人物名/组织名/地名**(用原文里的名字),丢掉一次性龙套和琐碎动作。" +
  "\n- 控制在 **200–320 字**,宁可概括也不要流水账。" +
  "\n- 只输出这段梗概正文,不要任何前后缀说明。";

/**
 * Compress a folded run of aged synopses into one arc paragraph.
 * @param range e.g. "第1集–第82集" (for context only)
 * @param foldedText the folded entries, one per line ("<label>：<line>")
 */
export async function runArcSummary(
  executor: LlmTaskExecutor,
  range: string,
  foldedText: string,
  signal?: AbortSignal,
): Promise<string> {
  const res = await executor.generateText("ingest.arc-summary", {
    system: ARC_SUMMARY_SYSTEM,
    user: `把下面 ${range} 的逐条剧情浓缩成一段篇章梗概(200–320 字,连贯成段,不要逐集罗列):\n\n${foldedText}`,
    ...(signal ? { signal } : {}),
  });
  return res.text.trim();
}
